import useAPI from '@/hooks/useAPI';
import ReleaseOfInformationRepository from '@/repositories/ReleaseOfInformationRepository';

interface UseReleaseOfInformationParams {
  person_id: string;
}

export const useReleaseOfInformation = ({ person_id }: UseReleaseOfInformationParams) => {
  const releaseOfInformationRepository = ReleaseOfInformationRepository();

  return useAPI({
    queryKey: ['releaseOfInformation', person_id],
    queryFn: async () => {
      return await releaseOfInformationRepository.listForPerson(person_id);
    }
  });
};

export default useReleaseOfInformation;
